/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:23
 * @LastEditTime : 2024-06-07 16:36:09
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\basicConfig\Sitequality.js
 */
/*--1.保存检测频率*/
import request from '@/utils/request'
export function saveStationTest(data) {
	return request({
		url: '/icps/system/sign/basics/qualityDetection/saveStationTest',
		method: 'post',
		data
	})
}
export function saveStationFrequency(data) {
	return request({
		url: '/icps/system/sign/basics/qualityDetection/saveStationFrequency',
		method: 'post',
		data
	})
}
/*--2.获取检测频率*/
// export function getStationTest(data) {
// 	return request({
// 		url: '/icps/system/sign/basics/qualityDetection/getStationTest',
// 		method: 'post',
// 		data
// 	})
// }
export function getStationTest(data) {
	return request({
		url: '/icps/system/sign/basics/qualityDetection/getStationTest',
		method: 'post',
		data
	})
}
export function getStationFrequency(data) {
	return request({
		url: '/icps/system/sign/basics/qualityDetection/getStationFrequency',
		method: 'post',
		data
	})
}
/*--3.获取验收标准*/
export function getStationNormByDetection(data) {
	return request({
		url: '/icps/system/sign/basics/qualityDetection/getStationNormByDetection',
		method: 'post',
		data
	})
}
/*--4.保存验收标准*/
export function saveNormByDetection(data) {
	return request({
		url: '/icps/system/sign/basics/qualityDetection/saveStationNormByDetection',
		method: 'post',
		data
	})
}